import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App as AntdApp, ConfigProvider, theme } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { router } from './router'
import { setupInterceptors } from '@/shared/services/api/interceptors'
import { apiClient } from '@/shared/services/api/client'
import { MultiProjectJobStoreProvider } from '@/modules/detection-task/context/MultiProjectJobStoreContext'
import { MultiProjectJobFloatingIndicator } from '@/modules/detection-task/components/MultiProjectJobFloatingIndicator'

// 初始化API拦截器
setupInterceptors(apiClient)

// 创建Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5分钟
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        locale={zhCN}
        theme={{
          token: {
            colorPrimary: '#1890ff',
            borderRadius: 8,
          },
          components: {
            Button: {
              colorPrimary: '#1890ff',
              algorithm: true,
            },
          },
        }}
        button={{
          autoInsertSpace: false,
        }}
        modal={{
          styles: {
            mask: {
              backdropFilter: 'blur(8px)',
              backgroundColor: 'rgba(0, 0, 0, 0.45)',
            },
            header: {
              paddingBottom: '16px',
              marginBottom: '16px',
              borderBottom: '1px solid #f0f0f0',
            },
            body: {
              padding: '24px',
              fontSize: '14px',
              lineHeight: '1.6',
            },
            footer: {
              paddingTop: '16px',
              marginTop: '16px',
              borderTop: '1px solid #f0f0f0',
            },
          },
        }}
      >
        <AntdApp>
          <MultiProjectJobStoreProvider>
            <MultiProjectJobFloatingIndicator />
            <RouterProvider router={router} />
          </MultiProjectJobStoreProvider>
        </AntdApp>
      </ConfigProvider>
    </QueryClientProvider>
  )
}

export default App
